module.exports = __webpack_public_path__ + "static/img/img-yybs.e211dab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/pc/img-yybs.png
// module id = Z2QW
// module chunks = 0